export enum QaPhotoAngle {
  FRONT = "4197d517-0d06-4991-8ed8-b8ffc37b379c",
  BACK = "7d2efe92-f3fa-4b39-a55c-6517fdba4b83",
  LEFT = "a448c312-e872-45b1-aeb9-6f2a1345deb1",
  RIGHT = "9ab8b544-2c4b-4bd0-bb24-e3bf489a1b3b",
  OTHER = "a03dd767-3877-42ae-998a-c860bcd9affb",
}
